exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px) {\n\n  .Services_link_1etB {\n    position: relative;\n    margin: -23px -20px;\n    padding: 23px 20px;\n    display: block;\n  }\n\n  .Services_link_1etB span {\n    border-bottom: none;\n  }\n}\n\n.Services_arrow_2Dfh {\n  -webkit-transition: none;\n  transition: none;\n}\n\n@media (min-width: 768px) {\n\n  .Services_arrow_2Dfh {\n    display: none;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"link": "Services_link_1etB",
	"arrow": "Services_arrow_2Dfh"
};